// export const base_url = 'http://3.131.16.17/api/v1/ezzytrace/'                      //OLD-TEST

//export const base_url = 'https://ezzyimports.com:83/api/v1/ezzytrace/'               //PROD 

// export const base_url = 'http://18.222.190.66:83/api/v1/ezzytrace/'                //DEV-TEST

// export const base_url = 'http://18.190.67.239:83/api/v1/ezzytrace/'               //PROD-IP
// export const base_url = 'https://www.ezzyship.com:8889/api/v1/ezzytrace/'
export const base_url = 'https://www.ezzydeliver.com:81/api/v1/ezzytrace/'